module.exports = {"150205001":"石拐街道","150205002":"大发街道","150205003":"大磁街道","150205004":"五当沟街道","150205005":"白狐沟街道","150205006":"大德恒街道","150205101":"五当召镇","150205202":"吉忽伦图苏木","150205400":"工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150205.json
// module id = 493
// module chunks = 0